var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4596 15.1659C23.4596 20.9992 19.3763 23.9159 14.523 25.6076C14.2688 25.6937 13.9928 25.6896 13.7413 25.5959C8.8763 23.9159 4.79297 20.9992 4.79297 15.1659V6.99922C4.79297 6.6898 4.91589 6.39306 5.13468 6.17426C5.35347 5.95547 5.65022 5.83256 5.95964 5.83256C8.29297 5.83256 11.2096 4.43256 13.2396 2.65922C13.4868 2.44805 13.8012 2.33203 14.1263 2.33203C14.4514 2.33203 14.7658 2.44805 15.013 2.65922C17.0546 4.44422 19.9596 5.83256 22.293 5.83256C22.6024 5.83256 22.8991 5.95547 23.1179 6.17426C23.3367 6.39306 23.4596 6.6898 23.4596 6.99922V15.1659Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/Risk.0ffb2a69246cc164e5469ea83f8f6457.svg";
export { ForwardRef as ReactComponent };